/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/services/app.print.service.ts.
 */
import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

/**
 * Zweck: Beschreibt class AppPrintService und ihren Daten- oder Funktionsvertrag.
 */
@Injectable({providedIn: 'root'})
export class AppPrintService {
  printing = new BehaviorSubject<boolean>(false);
  printing$ = this.printing.asObservable();

/**
 * Beschreibt Methode start und ihren Rückgabevertrag.
 */
  start() {
    this.printing.next(true);
  }

/**
 * Beschreibt Methode finish und ihren Rückgabevertrag.
 */
  finish() {
    this.printing.next(false);
  }
}
